import React, { useState } from 'react';
import Background from "../../../assets/images/background/banner.jpg";
import { Link } from 'react-router-dom';

import Arrow from "../../../assets/images/Services/right-arrow.png";
import { FaCheckCircle } from "react-icons/fa";


import img1 from "../../../assets/images/Product/Sales/image.png";
import img2 from "../../../assets/images/Product/Sales/image2.png";
import img3 from "../../../assets/images/Product/Sales/image3.png";
import img4 from "../../../assets/images/Product/Sales/image4.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import SEO from '../../seo';

export default function Sales() {
    const [openImageIndex, setOpenImageIndex] = useState(null);

    const images = [img1, img2, img3, img4];

     const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ];


    return (
        <div>
      <SEO
                title="Sales & Accounting"
                description="At HWPL! we recognize that privacy is important. This Privacy Policy applies to all products and services provided by us. Collection Of Information Disclaimer: Please read and edit the Privacy Policy given below as per your /website’s requirement. Don’t use or apply these as is basis on your website. We collect various information when you [&hellip;]"
                canonical="https://www.hwplindia.com/products/sales-accounting/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2024/01/erp-crm-development-company-banner-img.png"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Sales & Accounting</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>
                            <Link to="/products">Products</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Sales & Accounting</li>
                    </ul>
                </div>
            </section>
            <section className="branding-section1">
                <div className="at-container">

                    {/* Content Section */}
                    <div className="branding-content">
                        {/* CTA */}
                        <section className="cta-section attendance-h3">
                            <h3 className=''>“Sales & Accounting Management with Stock & Purchase Control”</h3>
                            <p>
                                At Horizon Webinfo Pvt. Ltd. we help businesses streamline sales, purchasing, inventory, and accounting through a unified, intelligent management system. Designed for wholesalers, distributors, and retailers, our solution brings complete visibility and control over daily operations while reducing manual work.
                            </p>
                            <h3 className='cta-section-business-process it-consult attendance-consult'>Why an Integrated Sales & Accounting System?
                            </h3>
                        </section>


                        {/* Sections */}
                        <section className='it-consult simple-section'>
                            <section className="branding-item">
                                <h4><img src={Arrow} />
                                    Centralized Control for Sales, Stock & Finance</h4>
                                <p>
                                    Managing orders, purchases, and accounts separately creates errors and inefficiencies. Our unified platform ensures all departments work in sync — improving accuracy, speed, and decision-making.
                                </p>
                            </section>

                            <section className="branding-item">
                                <h4><img src={Arrow} />
                                    Real-Time Inventory Insights</h4>
                                <p>
                                    Businesses lose revenue due to over-stocking, dead stock, or stock-outs. With real-time inventory tracking and automated alerts, you always know exactly what you have and what you need.

                                </p>
                            </section>

                            {/* Our Expertise in Attendance */}
                            <section className="cta-section">
                                <h3 className='cta-section-business-process attendance-expert'>Our Expertise in Sales, Stock & Accounting Automation
                                </h3>
                            </section>
                            <section className='simple-section attaaa'>

                                <section className="attendance-li">
                                    <h4>
                                        Sales Management</h4>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Quotation creation, sales orders & invoicing</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Customer management & pricing workflows</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> GST-ready invoices with auto tax calculation</li></p>
                                </section>

                                <section className="attendance-li">
                                    <h4>
                                        Purchase & Supplier Management</h4>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Purchase orders with supplier tracking</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Pending orders & inward tracking</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Supplier ledger & purchase history</li></p>
                                </section>

                                <section className="attendance-li">
                                    <h4>
                                        Inventory & Warehouse Control</h4>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Real-time stock updates</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Multi-warehouse management</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Stock movement logs & automated alerts</li></p>
                                </section>

                                <section className="attendance-li">
                                    <h4>
                                        Accounting & Finance
                                    </h4>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Expense tracking</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Financial accounting with ledgers & journals</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> GST reports, profit/loss & balance sheet</li></p>
                                </section>

                                <section className="attendance-li">
                                    <h4>
                                        Multi-Branch & Custom Workflow Support
                                    </h4>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Centralized data across all branches</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> User access controls & role permissions</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Workflows customized as per your business needs
                                    </li></p>
                                </section>
                            </section>

                            <div className='image-swip'>
                                <Swiper
                                    modules={[Navigation, Pagination, Autoplay]}
                                    slidesPerView={3}          // show 2 images at a time
                                    spaceBetween={30}
                                    slidesPerGroup={1}         // slide one by one
                                    navigation={false}
                                    pagination={{ clickable: true, dynamicBullets: false }}
                                    autoplay={{
                                        delay: 2500,
                                        disableOnInteraction: false,
                                    }}
                                    loop={true}
                                                breakpoints={{
                                        // Mobile
                                        0: {
                                            slidesPerView: 1,
                                        },

                                        // Small devices (landscape phones)
                                        576: {
                                            slidesPerView: 2,
                                        },

                                        // Tablets
                                        1015: {
                                            slidesPerView: 3,
                                        },

                                        // Desktop
                                        1330: {
                                            slidesPerView: 3,
                                        },
                                    }}
                                    className="branding-swiper lead-swiper"
                                >

                                    <SwiperSlide onClick={() => setOpenImageIndex(0)}>
                                        <img src={img1} className="attendance-img lead" />
                                    </SwiperSlide>

                                    <SwiperSlide onClick={() => setOpenImageIndex(1)}>
                                        <img src={img2} className="attendance-img lead" />
                                    </SwiperSlide>

                                    <SwiperSlide onClick={() => setOpenImageIndex(2)}>
                                        <img src={img3} className="attendance-img lead" />
                                    </SwiperSlide>

                                    <SwiperSlide onClick={() => setOpenImageIndex(3)}>
                                        <img src={img4} className="attendance-img lead" />
                                    </SwiperSlide>

                                </Swiper>
                                {openImageIndex !== null && (
                                    <div className="image-popup">

                                        <div className="close-btn" onClick={() => setOpenImageIndex(null)}>
                                            ✕
                                        </div>

                                        <div className="popup-img-wrapper">

                                            <button
                                                className="popup-swiper-arrow left"
                                                onClick={() =>
                                                    setOpenImageIndex(
                                                        (openImageIndex - 1 + images.length) % images.length
                                                    )
                                                }
                                            >
                                                ❮
                                            </button>

                                            <img
                                                src={images[openImageIndex]}
                                                alt="preview"
                                                className="popup-big-img"
                                            />

                                            <button
                                                className="popup-swiper-arrow right"
                                                onClick={() =>
                                                    setOpenImageIndex((openImageIndex + 1) % images.length)
                                                }
                                            >
                                                ❯
                                            </button>

                                        </div>

                                    </div>
                                )}

                            </div>

                            {/* Why This Helps Your Business */}

                            <section className="cta-section simple-section1">
                                <h3 className='cta-section-business-process attendance-expert why-lead'>Why This Helps Your Business</h3>
                            </section>

                            <section className="simple-section">
                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4>Complete Real-Time Visibility</h4>
                                        <p>Know your stock levels, sales status, financials, and purchase status instantly — all in one place.
                                        </p>
                                    </div>
                                </div>

                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4> Prevent Over-Stocking & Stock-Outs
                                        </h4>
                                        <p>Avoid unnecessary stock purchases and ensure you always have the right inventory when needed.</p>
                                    </div>
                                </div>

                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4>Reduce Manual Errors</h4>
                                        <p>Automated calculations for invoices, tax, stock updates, and accounts remove human mistakes.
                                        </p>
                                    </div>
                                </div>

                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4>Improve Cash Flow & Profitability</h4>
                                        <p>Clear financial reports help you control expenses, track receivables, and improve overall profitability.
                                        </p>
                                    </div>
                                </div>

                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4>Synchronize Your Entire Team</h4>
                                        <p>Sales, purchase, store, and accounts teams work on one integrated system, improving coordination and accountability.</p>
                                    </div>
                                </div>
                            </section>

                            {/* Why Choose Us */}
                            <section className="why-choose attendance-choose">
                                <h3>Who Is This Ideal For?</h3>
                                <ul>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Wholesalers</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Distributors</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Manufacturers</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Retailers</li>
                                </ul>
                            </section>

                            {/* CTA */}
                            <section className="cta-section attendance-p">
                                <h3>Collaborate with Us</h3>
                                <p>
                                    At Horizon Webinfo Pvt. Ltd. we bring together technology and business intelligence to create solutions that simplify operations and strengthen financial control. Our Sales & Accounting Management System adapts to your workflow and scales with your business growth.

                                </p>
                                <Link to="/get-a-quote" className="quote-btn1-brand">
                                    <span><i aria-hidden="true" class="fas fa-external-link-alt"></i> GET A QUOTE</span>
                                </Link>
                            </section>
                        </section>
                    </div>
                </div>
            </section>
        </div>
    );
}